<template>
  <div>
  <section>
    <div class="left"><h2 v-translate>Obecná Konfigurace</h2></div>
    <div class="right">
      <div class="field_left">
        <checkbox-input
            id="ignoreadvertisementsettings"
            v-model="entity.ignore_advertisement_settings"
            :disabled="!isEditable"
        >
          <translate class="translate">Ignorovat nastavení reklamního systému</translate>
        </checkbox-input>
        <checkbox-input
            id="canmodifyrestricteddevicegroups"
            v-model="entity.can_modify_restricted_device_groups"
            :disabled="!isEditable"
        >
          <translate class="translate">Může vytvářet vlastní skupiny zakázaných zařízení ke kanálům</translate>
        </checkbox-input>
      </div>
      <div class="field_right">
        <text-input id="maxuserlogintokens"
                    ref="maxuserlogintokensref"
                    :required="true"
                    v-model="entity.maximum_user_login_tokens"
                    :disabled="!isEditable"
        >
          <translate class="translate">Max. počet přihlášovacích tokenů uživatele</translate>
        </text-input>
      </div>
      <div class="field_right">
        <text-input
            v-model="entity.session_token_expiration_minutes"
            id="sessiontokenexpirationminutes"
            ref="sessiontokenexpirationminutesref"
            :disabled="!isEditable"
        ><translate class="translate">Čas vypršení API session tokenu v minutách</translate></text-input>
      </div>
      <div class="field_left">
        <select-box
            id="delete_unused_device"
            :options="nullableBooleanOptions"
            v-model="deleteUnusedDevice"
            :disabled="!isEditable"
            ref="deleteunuseddeviceref"
            :help-text="$gettext('platí pro secondScreen zařízení')"
        >
          <translate class="translate">Promazávat nepoužívaná zařízení</translate>
        </select-box>
        <text-input
            id="delete_unused_device_days"
            v-model="entity.delete_unused_device_days"
            ref="deleteunuseddevicedaysref"
            :disabled="!entity.delete_unused_device || !isEditable"
        >
          <translate class="translate">Počet dní neaktivity zařízení před smazáním</translate></text-input>
      </div>
      <div class="field_right">
        <text-input
            v-model="entity.subscriber_token_expiration_days"
            id="subscribertokenexpirationminutes"
            ref="subscribertokenexpirationminutesref"
            :disabled="!isEditable"
        ><translate class="translate">Čas vypršení subscriber tokenu ve dnech</translate></text-input>
      </div>
    </div>
  </section>
    <section>
      <div class="left"><h2 v-translate>Nastavení geoblokace</h2></div>
      <div class="right">
        <div class="field_left">
          <checkbox-input
              id="allowgeoblocking"
              v-model="entity.allow_geoblocking"
              ref="allowgeoblockingref"
              :disabled="!isEditable"
          >
            <translate class="translate">Používat geoblokaci</translate>
          </checkbox-input>
          <checkbox-input
              id="allowcustomgeoblockingprivateips"
              v-model="entity.custom_geoblocking_private_ips"
              ref="allowcustomgeoblockingprivateipsref"
              :disabled="!isEditable || !entity.allow_geoblocking"
          >
            <translate class="translate">Vlastní povolené privátní rozsahy IP adres</translate>
          </checkbox-input>
        </div>
        <div class="field_right">
          <text-input id="geoblockingcountrycodes"
                      ref="geoblockingcountrycodesref"
                      v-model="entity.geoblocking_country_codes"
                      :disabled="!isEditable || !entity.allow_geoblocking"
                      :help-text="$gettextInterpolate(
                          $gettext('Kódy států ve formátu ISO 3166-1 alpha-3 oddělené čárkami. Platformou nastaveno:  %{value}'),
                          { value: platformGeoblockingCountryCodes }
                          )"
          >
            <translate class="translate">Geoblokace - Seznam povolených států</translate>
          </text-input>
        </div>
      </div>
      <GeoblockingPrivateIpList
          v-if="entity.allow_geoblocking && entity.custom_geoblocking_private_ips"
          :is-editable="isEditable"
          :id-operator="entity.id"
      />
    </section>
    <section>
      <div class="left"><h2 v-translate>Balíčky a služby</h2></div>
      <div class="right">
        <div class="field_left">
          <text-input
              v-model="programmingStructureUrl"
              :disabled="true"
          ><translate class="translate">Programová skladba</translate></text-input>
        </div>
        <div class="field_right">
          <checkbox-input
              id="canaddchannelstoservice"
              v-model="entity.can_add_channels_to_service"
              ref="canaddchannelstoserviceref"
              :disabled="!isEditable"
          >
            <translate class="translate">Může přidávat kanály ke službám</translate>
          </checkbox-input>
          <checkbox-input
              id="cancreatechannelpackage"
              v-model="entity.can_create_channel_package"
              :disabled="!isEditable"
          >
            <translate class="translate">Může vytvářet balíčky</translate>
          </checkbox-input>
          <checkbox-input
              id="canaddchannelstoownchannelpackage"
              v-model="entity.can_add_channels_to_own_channel_package"
              :disabled="!isEditable"
          >
            <translate class="translate">Může editovat vlastní balíčky</translate>
          </checkbox-input>
        </div>
      </div>
    </section>
    <section>
      <div class="left"><h2 v-translate>Odběratelé a zařízení</h2></div>
      <div class="right">
        <div class="field_left">
          <select-box id="defaultsubscribertype"
                      ref="defaultsubscribertyperef"
                      :required="true"
                      v-model="entity.default_subscriber_type_id"
                      :options="subscriberTypeOptions"
                      :disabled="!isEditable"
          >
            <translate class="translate">Výchozí typ odběratele</translate>
          </select-box>
        </div>
        <div class="field_right">
          <text-input id="maxtestingsubscribercount"
                      ref="maxtestingsubscribercountref"
                      :required="true"
                      v-model="entity.maximum_testing_subscriber_count"
                      :disabled="!isEditable"
          >
            <translate class="translate">Max. počet testovacích odběratelů</translate>
          </text-input>
        </div>
        <div class="field_left">
          <text-input id="maxsubscriberdevicecount"
                      ref="maxsubscriberdevicecountref"
                      :required="true"
                      v-model="entity.maximum_subscriber_paired_device_count"
                      :disabled="!isEditable"
          >
            <translate class="translate">Max. počet spárovaných zařízení pro odběratele</translate>
          </text-input>
        </div>
        <div class="field_right">
          <text-input id="defaultparentallockpin"
                                             ref="defaultparentallockpinref"
                                             :required="true"
                                             v-model="entity.default_subscriber_parental_lock_pin"
                                             :disabled="!isEditable"
        >
          <translate class="translate">Výchozí hodnota PIN administrátora</translate>
        </text-input>
         </div>
        <div class="field_left">
          <text-input
              id="defaultsubscribermaxpaireddevicecount"
              ref="defaultsubscribermaxpaireddevicecountref"
              :required="true"
              v-model="entity.default_subscriber_maximum_paired_device_count"
              :disabled="!isEditable"
              :help-text="$gettext('Předvyplněná hodnota při vytváření nového odběratele.')"
          >
            <translate class="translate">Výchozí max. počet spárovaných zařízení odběratele</translate>
          </text-input>
        </div>
        <div class="field_right">
          <text-input id="defaultpairingcodeexpiration"
                      ref="defaultpairingcodeexpirationref"
                      :required="true"
                      v-model="entity.default_pairing_code_expiration_period_in_minutes"
                      :disabled="!isEditable"
          >
            <translate class="translate">Výchozí platnost párovacího kódu (min)</translate>
          </text-input>
        </div>
        <div class="field_left">
          <select-box id="idcurrency"
                      ref="idecurrencyref"
                      v-model="entity.id_currency"
                      :options="currencyOptions"
                      :disabled="!isEditable"
          >
            <translate class="translate">Výchozí měna</translate>
          </select-box>
        </div>
        <div class="field_right">
          <select-box id="defaultdevicelanguage"
                      ref="defaultdevicelanguageref"
                      :required="true"
                      :options="languageOptions"
                      v-model="entity.default_device_language"
                      :disabled="!isEditable"
          >
            <translate class="translate">Výchozí jazyk zařízení</translate>
          </select-box>
        </div>
        <div class="field_left">
          <text-input id="resetpasswordcontactemail"
                      ref="resetpasswordcontactemailref"
                      v-model="entity.contact_email"
                      :disabled="!isEditable"
          >
            <translate class="translate">E-mail odesílatele při obnově hesla odběratele</translate>
          </text-input>
        </div>
        <div class="field_right">
          <checkbox-input
              id="shape"
              v-model="entity.shape"
              :disabled="!isEditable"
          >
            <translate class="translate">Shapovat všechna zařízení</translate>
          </checkbox-input>
        </div>
      </div>
    </section>
    <section>
      <div class="left"><h2 v-translate>Nahrávky a oblíbené pořady</h2></div>
      <div class="right">
        <div class="field_left">
          <select-box
            id="allowfavoriteshows"
            :options="nullableBooleanOptions"
            v-model="allowFavoriteShows"
            :disabled="!isEditable"
            ref="allowfavoriteshowsref"
        >
          <translate class="translate">Povolit oblíbené pořady</translate>
        </select-box>
        </div>
        <div class="field_right">          <checkbox-input
            id="useglobalpvrstorage"
            v-model="entity.use_global_pvr_storage"
            ref="useglobalpvrstorage"
            :disabled="!isEditable"
        >
          <translate class="translate">Používá globální storage pro nahrávky</translate>
        </checkbox-input>
          <checkbox-input
              id="expirepvroncreationtime"
              v-model="entity.expire_pvr_on_creation_time"
              :disabled="!isEditable"
          >
            <translate class="translate">Expirace nahrávky dle času vytvoření</translate>
          </checkbox-input>
        </div>
        <div class="field_left">
          <text-input id="maximumfavoriteshows"
                      ref="maximumfavoriteshowsref"
                      v-model="entity.maximum_favorite_shows"
                      :disabled="disableMaximumFavoriteShows"
          >
            <translate class="translate">Maximální počet oblíbených pořadů</translate>
          </text-input>
        </div>
      </div>
    </section>
    <section>
      <div class="left"><h2 v-translate>EPG</h2></div>
      <div class="right">
        <div class="field_left">
          <text-input id="maxepgviewback"
                      ref="maxepgviewbackref"
                      :required="true"
                      v-model="entity.maximum_epg_view_back_in_hours"
                      :disabled="!isEditable"
          >
            <translate class="translate">Max. délka zpětného zobrazení EPG (hod)</translate>
          </text-input>
        </div>
        <div class="field_right">
          <text-input id="maxepgviewforward"
                      ref="maxepgviewforwardref"
                      :required="true"
                      v-model="entity.maximum_epg_view_forward_in_hours"
                      :disabled="!isEditable"
          >
            <translate class="translate">Max. délka budoucího zobrazení EPG (hod)</translate>
          </text-input>
        </div>
      </div>
    </section>
    <section>
      <div class="left"><h2 v-translate>Samoobsluha</h2></div>
      <div class="right">
        <div class="field_left">
        <checkbox-input
            id="selfserviceallowed"
            v-model="entity.selfservice_allowed"
            :disabled="!allowEditSelfservice"
        >
          <translate class="translate">Povolená samoobsluha</translate>
        </checkbox-input>
          </div>
        <div class="field_left">
          <text-input id="selfserviceurl"
                      ref="selfserviceurlref"
                      v-model="entity.selfservice_url"
                      :disabled="!allowEditSelfservice || !entity.selfservice_allowed"
          >
            <translate class="translate">URL samoobsluhy</translate>
          </text-input>
        </div>
        <div class="field_right">
          <text-input id="selfserviceapikey"
                      ref="selfserviceapikeyref"
                      v-model="entity.selfservice_api_key"
                      :disabled="!allowEditSelfservice || !entity.selfservice_allowed"
          >
            <translate class="translate">API KEY samoobsluhy</translate>
          </text-input>
        </div>
      </div>
    </section>
  <section>
    <div class="left"><h2 v-translate>Reporting</h2></div>
    <div class="right">
      <div class="field_left">
        <select-box
            id="reportsubscribersafterfirstmonth"
            :options="nullableBooleanOptions"
            v-model="reportSubscribersAfterFirstMonth"
            :disabled="!isEditable"
            ref="reportsubscribersafterfirstmonthref"
            :help-text="$gettext('Naposledy změněno')+': '+reportSubscriberAfterFirstMonthLastChange"
        >
          <translate class="translate">Reportovat nové odběratele od 1. dne následujícího měsíce</translate>
        </select-box>
      </div>
      <div class="field_right">
        <text-input id="includeddevicecount"
                    ref="includeddevicecountref"
                    type="number"
                    v-model="entity.included_device_count"
                    :disabled="!isEditable"
                    :help-text="$gettextInterpolate(
        $gettext('Počet zařízení odběratele bez poplatku - pro reporting. Hodnota z Business modelu: %{value}'),
        { value: businessModelIncludedDeviceCount }
        )"
        >
          <translate class="translate">Počet simultánně stream. zařízení v ceně</translate>
        </text-input>
      </div>
      <div class="field_left">
        <text-input id="includedfirstscreendevicecount"
                    ref="includedfirstscreendevicecountref"
                    type="number"
                    v-model="includedFirstscreeenDeviceCount"
                    :disabled="!isEditable"
                    :help-text="$gettextInterpolate(
        $gettext('Počet firstscreen zařízení odběratele bez poplatku - pro reporting. Hodnota z Business modelu:  %{value}'),
        { value: businessModelIncludedFirstscreenDeviceCount }
        )"
        >
          <translate class="translate">Počet firstscreen zařízení v ceně</translate>
        </text-input>
      </div>
    </div>
  </section>
    <section>
      <div class="left"><h2 v-translate>Výchozí nastavení uživatelských profilů</h2></div>
      <div class="right">
        <div class="field_left">
          <select-box
              id="subscriberprofiledefaultpermissionspvrs"
              :options="defaultSubscriberProfilePermissionsPvrsOptions"
              v-model="entity.subscriber_profile_default_permission_pvrs"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultpermissionspvrsref"
          >
            <translate class="translate">Nahrávky</translate>
          </select-box>
        </div>
        <div class="field_right">
          <select-box
              id="subscriberprofiledefaultpermissionsdevicesettings"
              :options="booleanOptions"
              v-model="subscriberProfileDefaultPermissionsDeviceSettings"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultpermissionsdevicesettingsref"
          >
            <translate class="translate">Nastavení</translate>
          </select-box>
        </div>
        <div class="field_left">
          <select-box
              id="subscriberprofiledefaultpermissionsperiodicpvrs"
              :options="defaultSubscriberProfilePermissionsPvrsOptions"
              v-model="entity.subscriber_profile_default_permission_periodic_pvrs"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultpermissionsperiodicpvrsref"
          >
            <translate class="translate">Pravidelné nahrávky</translate>
          </select-box>
        </div>
        <div class="field_right">
          <select-box
              id="subscriberprofiledefaultpermissionsmessages"
              :options="booleanOptions"
              v-model="subscriberProfileDefaultPermissionsMessages"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultpermissionsmessagesref"
          >
            <translate class="translate">Oznámení</translate>
          </select-box>
        </div>
        <div class="field_left">
          <select-box
              id="subscriberprofiledefaultpermissionsselfservice"
              :options="booleanOptions"
              v-model="subscriberProfileDefaultPermissionsSelfservice"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultpermissionsselfserviceref"
          >
            <translate class="translate">Samoobsluha</translate>
          </select-box>
        </div>
        <div class="field_right">
          <select-box
              id="subscriberprofiledefaultpermissionschannelgroups"
              :options="booleanOptions"
              v-model="subscriberProfileDefaultPermissionsChannelGroups"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultpermissionschannelgroupsref"
          >
            <translate class="translate">Skupiny kanálů</translate>
          </select-box>
        </div>
        <div class="field_left">
          <select-box
              id="subscriberprofiledefaultpermissionsvod"
              :options="booleanOptions"
              v-model="subscriberProfileDefaultPermissionsVod"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultpermissionsvodref"
          >
            <translate class="translate">Videotéka</translate>
          </select-box>
        </div>
      </div>
    </section>
    <section>
      <div class="left"><h2 v-translate>Výchozí nastavení dětských uživatelských profilů</h2></div>
      <div class="right">
        <div class="field_left">
          <select-box
              id="subscriberprofiledefaultchildpermissionspvrs"
              :options="defaultSubscriberProfilePermissionsPvrsOptions"
              v-model="entity.subscriber_profile_default_child_permission_pvrs"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultchildpermissionspvrsref"
          >
            <translate class="translate">Nahrávky</translate>
          </select-box>
        </div>
        <div class="field_right">
          <select-box
              id="subscriberprofiledefaultchildpermissionsdevicesettings"
              :options="booleanOptions"
              v-model="subscriberProfileDefaultChildPermissionsDeviceSettings"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultchildpermissionsdevicesettingsref"
          >
            <translate class="translate">Nastavení</translate>
          </select-box>
        </div>
        <div class="field_left">
          <select-box
              id="subscriberprofiledefaultchildpermissionsperiodicpvrs"
              :options="defaultSubscriberProfilePermissionsPvrsOptions"
              v-model="entity.subscriber_profile_default_child_permission_periodic_pvrs"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultchildpermissionsperiodicpvrsref"
          >
            <translate class="translate">Pravidelné nahrávky</translate>
          </select-box>
        </div>
        <div class="field_right">
          <select-box
              id="subscriberprofiledefaultchildpermissionsmessages"
              :options="booleanOptions"
              v-model="subscriberProfileDefaultChildPermissionsMessages"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultchildpermissionsmessagesref"
          >
            <translate class="translate">Oznámení</translate>
          </select-box>
        </div>
        <div class="field_left">
          <select-box
              id="subscriberprofiledefaultchildpermissionsselfservice"
              :options="booleanOptions"
              v-model="subscriberProfileDefaultChildPermissionsSelfservice"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultchildpermissionsselfserviceref"
          >
            <translate class="translate">Samoobsluha</translate>
          </select-box>
        </div>
        <div class="field_right">
          <select-box
              id="subscriberprofiledefaultchildpermissionschannelgroups"
              :options="booleanOptions"
              v-model="subscriberProfileDefaultChildPermissionsChannelGroups"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultchildpermissionschannelgroupsref"
          >
            <translate class="translate">Skupiny kanálů</translate>
          </select-box>
        </div>
        <div class="field_left">
          <select-box
              id="subscriberprofiledefaultchildpermissionsvod"
              :options="booleanOptions"
              v-model="subscriberProfileDefaultChildPermissionsVod"
              :disabled="!isEditable"
              ref="subscriberprofiledefaultchildpermissionsvodref"
          >
            <translate class="translate">Videotéka</translate>
          </select-box>
        </div>
      </div>
    </section>
    <SubscriberProfileForm
        :entity="entity"
        :is-editable="isEditable"
        :is-operator="true"
    />
    <p></p>
  </div>
</template>

<script>
import {getCorrectBooleanValue} from "@/utils/helpers"
import GeoblockingPrivateIpList from "../../../common/GeoblockingPrivateIpList.vue";
import SubscriberProfileForm from "../../businessModels/Forms/SubscriberProfileForm.vue";

export default {
  name: "OperatorLicence",
  components: {SubscriberProfileForm, GeoblockingPrivateIpList},
  props: {
    entity: Object,
    subscriberTypeOptions: Array,
    isEditable: Boolean,
    geoblockingCountryCodes: Array,
    businessModelIncludedDeviceCount: Number,
    businessModelIncludedFirstscreenDeviceCount: Number,
  },
  data(){
    return {
      currencyOptions: [],
    }
  },
  created(CurrencyService){
    this.currencyService = CurrencyService;
    this.currencyService.getEntitiesForSelectBox({})
        .then((data) => {
          this.currencyOptions = data['currencies'];
          this.currencyOptions.unshift({'id': null, 'text': this.$gettext('Z nastavení platformy')});
        })
  },
  computed: {
    languageOptions() {
      return [
        {id: 'ces', text: this.$gettext('Česky')},
        {id: 'slk', text: this.$gettext('Slovensky')},
        {id: 'eng', text: this.$gettext('Anglicky')},
        {id: 'deu', text: this.$gettext('Německy')},
      ]
    },
    nullableBooleanOptions() {
      return [
        {id: null, text: this.$gettext('Neurčeno')},
        {id: true, text: this.$gettext('Ano')},
        {id: false, text: this.$gettext('Ne')},
      ]
    },
    booleanOptions() {
      return [
        {id: true, text: this.$gettext('Ano')},
        {id: false, text: this.$gettext('Ne')},
      ]
    },
    defaultSubscriberProfilePermissionsPvrsOptions() {
      return [
        {id: 'OWN', text: this.$gettext('Vlastní')},
        {id: 'ALL', text: this.$gettext('Všechny')},
        {id: 'NONE', text: this.$gettext('Žádné')},
      ]
    },
    programmingStructureUrl() {
      return window.location.origin + '/api/getChannelPackagesInfo/' + this.entity.api_key
    },
    disableMaximumFavoriteShows(){
      return !this.isEditable || this.allowFavoriteShows === false
    },
    allowFavoriteShows: {
      get() {
        return this.entity.allow_favorite_shows;
      },
      set(newValue) {
        this.entity.allow_favorite_shows = getCorrectBooleanValue(newValue)
      }
    },
    reportSubscribersAfterFirstMonth: {
      get() {
        return this.entity.report_subscribers_after_first_month
      },
      set(newValue) {
        this.entity.report_subscribers_after_first_month = getCorrectBooleanValue(newValue)
      }
    },
    deleteUnusedDevice:{
      get() {
        return this.entity.delete_unused_device
      },
      set(newValue) {
        this.entity.delete_unused_device = getCorrectBooleanValue(newValue)
      }
    },
    includedFirstscreeenDeviceCount: {
      get() {
        return this.entity.included_firstscreen_device_count
      },
      set(newValue) {
        this.entity.included_firstscreen_device_count = newValue.length ? newValue: null;
      }
    },
    subscriberProfileDefaultPermissionsMessages: {
      get() {
        return this.entity.subscriber_profile_default_permission_messages
      },
      set(newValue) {
        this.entity.subscriber_profile_default_permission_messages = getCorrectBooleanValue(newValue)
      }
    },
    subscriberProfileDefaultPermissionsDeviceSettings: {
      get() {
        return this.entity.subscriber_profile_default_permission_device_settings
      },
      set(newValue) {
        this.entity.subscriber_profile_default_permission_device_settings = getCorrectBooleanValue(newValue)
      }
    },
    subscriberProfileDefaultPermissionsSelfservice: {
      get() {
        return this.entity.subscriber_profile_default_permission_selfservice
      },
      set(newValue) {
        this.entity.subscriber_profile_default_permission_selfservice = getCorrectBooleanValue(newValue)
      }
    },
    subscriberProfileDefaultPermissionsChannelGroups: {
      get() {
        return this.entity.subscriber_profile_default_permission_channel_groups
      },
      set(newValue) {
        this.entity.subscriber_profile_default_permission_channel_groups = getCorrectBooleanValue(newValue)
      }
    },
    subscriberProfileDefaultPermissionsVod: {
      get() {
        return this.entity.subscriber_profile_default_permission_vod
      },
      set(newValue) {
        this.entity.subscriber_profile_default_permission_vod = getCorrectBooleanValue(newValue)
      }
    },
    subscriberProfileDefaultChildPermissionsMessages: {
      get() {
        return this.entity.subscriber_profile_default_child_permission_messages
      },
      set(newValue) {
        this.entity.subscriber_profile_default_child_permission_messages = getCorrectBooleanValue(newValue)
      }
    },
    subscriberProfileDefaultChildPermissionsDeviceSettings: {
      get() {
        return this.entity.subscriber_profile_default_child_permission_device_settings
      },
      set(newValue) {
        this.entity.subscriber_profile_default_child_permission_device_settings = getCorrectBooleanValue(newValue)
      }
    },
    subscriberProfileDefaultChildPermissionsSelfservice: {
      get() {
        return this.entity.subscriber_profile_default_child_permission_selfservice
      },
      set(newValue) {
        this.entity.subscriber_profile_default_child_permission_selfservice = getCorrectBooleanValue(newValue)
      }
    },
    subscriberProfileDefaultChildPermissionsChannelGroups: {
      get() {
        return this.entity.subscriber_profile_default_child_permission_channel_groups
      },
      set(newValue) {
        this.entity.subscriber_profile_default_child_permission_channel_groups = getCorrectBooleanValue(newValue)
      }
    },
    subscriberProfileDefaultChildPermissionsVod: {
      get() {
        return this.entity.subscriber_profile_default_child_permission_vod
      },
      set(newValue) {
        this.entity.subscriber_profile_default_child_permission_vod = getCorrectBooleanValue(newValue)
      }
    },
    platformGeoblockingCountryCodesHelpText(){
      return this.$gettext('kódy států ve formátu ISO 3166-1 alpha-3 oddělené čárkami. Platformou nastaveno: ');
    },
    platformGeoblockingCountryCodes(){
      return this.geoblockingCountryCodes && this.geoblockingCountryCodes.length > 0 ? this.geoblockingCountryCodes.join(', '): this.$gettext('povoleno ze všech států');
    },
    defaultCurrencyText(){
      return this.$gettext('Výchozí nastavení platformy: ');
    },
    reportSubscriberAfterFirstMonthLastChange(){
      return this.entity.report_subscribers_after_first_month_last_change ? this.$_datetime_format(this.entity.report_subscribers_after_first_month_last_change) : this.$gettext("Zatím nezměněno");
    },
    allowEditSelfservice(){
      return this.isEditable || this.$_loggedUser_action_allowed('operators', 'read', 'OWN');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/operators/settings/OperatorLicence.vue